import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../stores/authStore';

/**
 * ProtectedRoute - 상위 컴포넌트로 감싸서 로그인 상태 및 권한을 체크합니다.
 * @param {React.ReactNode} children - 보호할 자식 컴포넌트
 * @param {string[]} allowedRoles - 허용된 역할 배열 (예: ['admin', 'user'])
 * @returns {React.ReactNode}
 */
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    const { user, isAuthenticated } = useAuthStore();
    const location = useLocation();

    // 1. 로그인 여부 확인
    if (!isAuthenticated) {
        // 현재 위치를 state에 담아 로그인 후 다시 돌아올 수 있게 함
        return <Navigate to="/" state={{ from: location, msg: "로그인이 필요합니다." }} replace />;
    }

    // 2. 권한 확인 (allowedRoles가 지정된 경우만)
    if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
        alert("접근 권한이 없습니다.");
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
